import React from 'react';

export default () => {
    return (
        <div className="divider-bar">
            <div className="progress-bar-bar"/>
        </div>
    )
}